var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.closeFilter,
          expression: "closeFilter",
        },
      ],
      staticClass: "bb-period-filter statistic-period-filter",
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.alwaysOpen,
              expression: "!alwaysOpen",
            },
          ],
          staticClass: "bb-period-filter-buttons",
        },
        [
          _c(
            "button",
            {
              staticClass: "bb-period-filter-prev-btn",
              on: { click: _vm.decrementPeriod },
            },
            [_c("i", { staticClass: "la la-angle-left" })]
          ),
          _c(
            "div",
            {
              staticClass: "bb-period-filter-title",
              on: { click: _vm.toggleFilter },
            },
            [_c("span", [_vm._v(_vm._s(_vm.filterTitle))])]
          ),
          _c(
            "button",
            {
              staticClass: "bb-period-filter-next-btn",
              on: { click: _vm.incrementPeriod },
            },
            [_c("i", { staticClass: "la la-angle-right" })]
          ),
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isFilterOpen,
              expression: "isFilterOpen",
            },
          ],
          staticClass: "bb-card",
        },
        [
          _c(
            "v-tabs",
            {
              staticClass: "bb-tabs",
              attrs: { "background-color": "white", left: "" },
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _c(
                "v-tab",
                {
                  attrs: { href: "#day_tab", ripple: false },
                  on: {
                    click: function ($event) {
                      return _vm.updateActiveTab("day_tab")
                    },
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("statisticsFilters.periodFilter.dayLabel")
                      ) +
                      " "
                  ),
                ]
              ),
              _c(
                "v-tab",
                {
                  attrs: { href: "#month_tab", ripple: false },
                  on: {
                    click: function ($event) {
                      return _vm.updateActiveTab("month_tab")
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("statisticsFilters.periodFilter.monthLabel"))
                  ),
                ]
              ),
              _c(
                "v-tab",
                {
                  attrs: { href: "#year_tab", ripple: false },
                  on: {
                    click: function ($event) {
                      return _vm.updateActiveTab("year_tab")
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("statisticsFilters.periodFilter.yearLabel"))
                  ),
                ]
              ),
              _c(
                "v-tab-item",
                { attrs: { id: "day_tab" } },
                [
                  _c("b-calendar", {
                    ref: "smallCalendar",
                    attrs: {
                      "hide-header": true,
                      "today-variant": "success",
                      locale: _vm.locale,
                      "date-info-fn": _vm.dateClass,
                      "start-weekday": 1,
                    },
                    on: { context: _vm.onContext },
                    scopedSlots: _vm._u([
                      {
                        key: "nav-prev-month",
                        fn: function () {
                          return [
                            _c("i", {
                              staticClass:
                                "la la-arrow-left b-calendar-custom-nav",
                            }),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "nav-next-month",
                        fn: function () {
                          return [
                            _c("i", {
                              staticClass:
                                "la la-arrow-right b-calendar-custom-nav",
                            }),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "nav-this-month",
                        fn: function () {
                          return [
                            _c(
                              "span",
                              {
                                staticClass: "b-calendar-month-string",
                                staticStyle: { "margin-right": "5px" },
                              },
                              [_vm._v(_vm._s(_vm.dayTabData.monthString))]
                            ),
                            _c(
                              "span",
                              { staticClass: "b-calendar-year-string" },
                              [_vm._v(_vm._s(_vm.dayTabData.yearString))]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                    model: {
                      value: _vm.dayTabData.selectedDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.dayTabData, "selectedDate", $$v)
                      },
                      expression: "dayTabData.selectedDate",
                    },
                  }),
                ],
                1
              ),
              _c("v-tab-item", { attrs: { id: "month_tab" } }, [
                _c("div", { staticClass: "month-presentation-navigation" }, [
                  _c(
                    "button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.updateMonthTabData({
                            year: parseInt(_vm.monthTabData.yearString) - 1,
                          })
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "la la-arrow-left b-calendar-custom-nav",
                      }),
                    ]
                  ),
                  _c("span", { staticClass: "b-calendar-month-string" }, [
                    _vm._v(_vm._s(_vm.monthTabData.yearString)),
                  ]),
                  _c(
                    "button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.updateMonthTabData({
                            year: parseInt(_vm.monthTabData.yearString) + 1,
                          })
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "la la-arrow-right b-calendar-custom-nav",
                      }),
                    ]
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "row month-presentation-container" },
                  _vm._l(_vm.months, function (month, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "month-presentation col-4",
                        class:
                          month === _vm.monthTabData.monthString
                            ? "active"
                            : "",
                      },
                      [
                        _c(
                          "span",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.updateMonthTabData({ month: month })
                              },
                            },
                          },
                          [_vm._v(_vm._s(month))]
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ]),
              _c("v-tab-item", { attrs: { id: "year_tab" } }, [
                _c(
                  "div",
                  { staticClass: "row month-presentation-container" },
                  _vm._l(_vm.years, function (year, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "month-presentation col-4",
                        class:
                          year === _vm.yearTabData.yearString ? "active" : "",
                      },
                      [
                        _c(
                          "span",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.updateYearTabData(year)
                              },
                            },
                          },
                          [_vm._v(_vm._s(year))]
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }